import {HeaderAppearance} from '../types/Header'

export const isDarkTheme = (appearance?: HeaderAppearance): boolean => appearance === 'dark'
